/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdipartnerXcompOrders.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edipartner-xcomp-orders";

export class AutogenModelEdipartnerXcompOrders<RowType extends ModelRow> extends Endpoint<RowType, RowEdipartnerXcompOrdersFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdipartnerXcompOrders extends ModelRow<RowEdipartnerXcompOrdersFields> {
	constructor(values?: Partial<RowEdipartnerXcompOrdersFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdipartnerXcompOrdersFields {
	company_id: string;
	"edi_xcompare.caption": string;
	"edi_xcompare.company_id": string;
	"edi_xcompare.data_type": string;
	"edi_xcompare.fieldname": string;
	"edi_xcompare.id": string;
	"edi_xcompare.source_fieldname": string;
	"edi_xcompare.source_tablename": string;
	"edi_xcompare.tablename": string;
	"edi_xcompare.transaction_set": string;
	edi_xcompare_id: string;
	exclude_field: string;
	id: string;
	partner_id: string;
	transaction_set: string;
	version: string;
}

